import React from "react";
import { Shield, ShieldCheck } from "lucide-react";

// Phase 18-B1 item 5: trust chip — a SHIELD, deliberately distinct from the
// medal-styled TierBadge (recognition). Trust levels are server-computed;
// this component only renders what the API returns.
//   L0 New neighbour · L1 Active neighbour · L2 Community-vouched · L3 DBS seen
// L3 copy is deliberately soft (2026-07): an org told us they've SEEN a
// certificate — CivicHearth doesn't check or store certificates.
export const DBS_JUDGEMENT_CLARIFIER =
  "An organisation has told us they've seen this volunteer's DBS certificate. " +
  "CivicHearth doesn't check or store certificates — always use your own judgement.";
const STYLES = {
  0: "bg-neutral-100 text-neutral-500 border border-neutral-200",
  1: "bg-forest/10 text-forest border border-forest/20",
  2: "bg-sky-100 text-sky-800 border border-sky-200",
  3: "bg-forest text-white border border-forest",
};

function attestationLine(att) {
  if (!att) return null;
  try {
    const d = new Date(att.seen_on + "T00:00:00Z");
    const when = d.toLocaleDateString("en-GB", { month: "long", year: "numeric" });
    return `DBS seen by ${att.org_name}, ${when}`;
  } catch {
    return `DBS seen by ${att.org_name}`;
  }
}

export const TrustChip = ({ trust, showZero = false, className = "" }) => {
  if (!trust || typeof trust.level !== "number") return null;
  if (trust.level === 0 && !showZero) return null;
  const Icon = trust.level >= 3 ? ShieldCheck : Shield;
  const line = trust.level >= 3 ? attestationLine(trust.attestation) : null;
  const title = trust.level >= 3
    ? `${line ? line + ". " : ""}${DBS_JUDGEMENT_CLARIFIER}`
    : `Trust level ${trust.level} — ${trust.label}`;
  return (
    <span
      data-testid={`trust-chip-l${trust.level}`}
      title={title}
      className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-medium align-middle ${STYLES[trust.level]} ${className}`}
    >
      <Icon className="w-3 h-3" />
      {trust.label}
    </span>
  );
};

export const trustAttestationLine = attestationLine;

export const TRUST_LABELS = {
  0: "New neighbour",
  1: "Active neighbour",
  2: "Community-vouched",
  3: "DBS seen",
};
